export default __webpack_public_path__ + "static/media/howworks1.479a498a.png";